// messageCenter/inboxEvents.js — the inbox page (its own Vite entry) and the inbox parts of the admin entry (button,
// window owner) on the same page talk by DOM events on the document, because they live in different bundles; no shared
// state (bigplan backend/message-center, steps 8b/8d). "Something was read or clicked away" → the counter follows;
// "show this notice in the window" → the page's one window owner shows it.

export const INBOX_CHANGED = 'topo:inbox-changed';

export function announceInboxChange(doc = document) {
    doc.dispatchEvent(new CustomEvent(INBOX_CHANGED));
}

/** "Here are the latest counts": the inbox button hands each summary on, the inbox page shows them on its tabs (11a). */
export const INBOX_SUMMARY = 'topo:inbox-summary';

export function announceSummary(summary, doc = document) {
    doc.dispatchEvent(new CustomEvent(INBOX_SUMMARY, { detail: { notices: summary.notices ?? 0, tickets: summary.tickets ?? 0 } }));
}

/** A count as shown on the envelope and the tabs: '' at 0, the number, '99+' from 100. Pure. */
export function countLabel(unread) {
    const n = Number(unread) || 0;
    if (n <= 0) { return ''; }
    return n > 99 ? '99+' : String(n);
}

/**
 * One showing of a pending notice: its id plus the time of its last "show again". Overlay and window owner remember
 * showings per page, so the 5-minute summary brings nothing twice, while a "show again" counts as new (smoke 8e).
 */
export function showingKey(notice) {
    return notice.thread_id + '|' + (notice.reshown_at ?? '');
}

/** "Show this notice in the window": the inbox page asks the page's window owner (noticeWindows.js, step 8d). */
export const OPEN_NOTICE_WINDOW = 'topo:notice-window-open';

export function openNoticeWindow(notice, doc = document) {
    doc.dispatchEvent(new CustomEvent(OPEN_NOTICE_WINDOW, { detail: { notice } }));
}
